export function buildId(raw) {
  const lineId = raw.lineId;
  const chatId = raw.chatId;

  return `${lineId}-${chatId}`;
}

export function normalize(raw) {
  if (!raw) return null;
  return {
    ...raw,
    id: buildId(raw),
  };
}
